import { InfoBlock, Input } from "@shared/ui.components";
import { colours } from "@shared/ui.design-system";
import { ChevronRightIcon } from "@shared/ui.icons";
import { Button, Typography } from "@shared/ui.primitives";
import React, { forwardRef } from "react";

import * as styles from "./OutOfStock.css";

export interface OutOfStockProps {
  handleSubmit?: ({ email }: { email: string }) => Promise<boolean>;
  submitted?: boolean;
}
export const OutOfStock = forwardRef<HTMLDivElement, OutOfStockProps>(
  ({ handleSubmit, submitted }, ref) => {
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState<string | null>(null);
    const handleFormSubmit = async (
      event: React.FormEvent<HTMLFormElement>
    ) => {
      event.preventDefault();
      setLoading(true);

      const formData = new FormData(event.currentTarget);
      const email = formData.get("email") as string;

      if (handleSubmit && email) {
        try {
          const ok = await handleSubmit({ email });
          if (!ok) {
            setError("Failed to register email. Please try again.");
          }
        } catch (err) {
          setError(
            "An error occurred while submitting the form. Please try again."
          );
          return err;
        }
      }
      setLoading(false);
    };
    return (
      <div className={styles.oosWrapper} ref={ref}>
        {submitted ? (
          <InfoBlock>
            <Typography variant="body-md">
              We will let you know when this item is available.
            </Typography>
          </InfoBlock>
        ) : (
          <>
            <Typography variant="subheader-6">
              Let me know when available
            </Typography>
            <form
              className={styles.formLayout}
              onSubmit={handleFormSubmit}
              data-testid="out-of-stock-form"
            >
              <Input
                type="text"
                placeholder="email@example.com"
                name="email"
                disabled={loading}
                className={styles.oosField}
              />
              <Button
                disabled={loading}
                type="submit"
                width="minContent"
                variant="primary"
                ariaLabel="Let me know"
                text=""
                leftIcon={
                  <ChevronRightIcon
                    width={20}
                    height={20}
                    color={colours.secondary.soft}
                  />
                }
              ></Button>
            </form>
            {error ? (
              <Typography variant="smallprint-md" colour="error-medium">
                {error}
              </Typography>
            ) : (
              <Typography variant="smallprint-md">
                We'll only notify you about this item returning.
              </Typography>
            )}
          </>
        )}
      </div>
    );
  }
);
